<template>
  <div>
    <li
      data-toggle="collapse"
      :data-target="linkAPI"
      class="collapsed api-navlink"
      @click="showItems"
    >
      <font-awesome-icon icon="angle-down" /> {{ api.title }}
    </li>
    <ul class="sub-menu collapse" :class="show" id="productsa">
      <Sublink
        v-for="(obj, index) in api.items"
        :key="index"
        :api="obj"
        :id="index"
        :link="api.link"
      />
    </ul>
  </div>
</template>

<script>
import Sublink from "./Sublink.vue";
export default {
  name: "Navlink",
  props: ["api", "groupsApis"],
  components: {
    Sublink,
  },
  data() {
    return {
      show: "",
      items: this.api.item,
    };
  },
  methods: {
    showItems() {
      this.show === "" ? (this.show = "show") : (this.show = "");
    },
  },
  computed: {
    // Name for route each group API
    linkAPI() {
      // Cut each title "API "
      return "#" + this.api.title.slice(4);
    },
  },
};
</script>